/**
 * Função para obter cor fixa baseada no label da resposta
 * @param {string} label - O label da resposta
 * @returns {string} - Cor hexadecimal correspondente
 */
export const getColorForResponse = (label) => {
    const labelLower = label.toLowerCase().trim();
    
    // Escala de concordância
    if (labelLower.includes('concordo totalmente') || labelLower === 'concordo totalmente') {
        return '#28a745'; // Verde forte
    } else if (labelLower.includes('concordo parcialmente') || labelLower === 'concordo parcialmente') {
        return '#90EE90'; // Verde claro
    } else if (labelLower.includes('neutro') || labelLower === 'neutro') {
        return '#ffeb3b'; // Amarelo claro
    } else if (labelLower.includes('discordo parcialmente') || labelLower === 'discordo parcialmente') {
        return '#ff9800'; // Laranja
    } else if (labelLower.includes('discordo totalmente') || labelLower === 'discordo totalmente') {
        return '#dc3545'; // Vermelho forte
    }
    
    // Escala de dificuldade (verificar ANTES de satisfação para pegar "Regular" no contexto correto)
    // Verificar "muito" ANTES de simples, pois contém a palavra
    if (labelLower.includes('muito difícil') || labelLower === 'muito difícil' || labelLower === 'muito dificil') {
        return '#dc3545'; // Vermelho forte
    } else if (labelLower.includes('muito fácil') || labelLower === 'muito fácil' || labelLower === 'muito facil') {
        return '#28a745'; // Verde forte
    } else if (labelLower === 'difícil' || labelLower === 'dificil' || (labelLower.includes('difícil') && !labelLower.includes('muito'))) {
        return '#ff9800'; // Laranja
    } else if (labelLower === 'fácil' || labelLower === 'facil' || (labelLower.includes('fácil') && !labelLower.includes('muito')) || (labelLower.includes('facil') && !labelLower.includes('muito'))) {
        return '#90EE90'; // Verde claro
    } else if (labelLower === 'regular' || labelLower.includes('regular')) {
        // Regular no contexto de dificuldade (amarelo) - verificar antes de satisfação
        return '#ffeb3b'; // Amarelo claro (mantém diferente de Satisfatório)
    }
    
    // Escala eficiente/ineficiente (verificar "muito" ANTES de simples, pois contém a palavra)
    if (labelLower.includes('muito ineficiente') || labelLower === 'muito ineficiente') {
        return '#dc3545'; // Vermelho forte
    } else if (labelLower.includes('muito eficiente') || labelLower === 'muito eficiente') {
        return '#28a745'; // Verde forte
    } else if (labelLower === 'ineficiente' || (labelLower.includes('ineficiente') && !labelLower.includes('muito'))) {
        return '#ff9800'; // Laranja
    } else if (labelLower === 'eficiente' || (labelLower.includes('eficiente') && !labelLower.includes('muito'))) {
        return '#90EE90'; // Verde claro
    }
    
    // Escala de satisfação (verificar insatisfatório ANTES de satisfatório, pois contém a palavra)
    if (labelLower.includes('excelente') || labelLower === 'excelente') {
        return '#28a745'; // Verde forte
    } else if (labelLower.includes('muito bom') || labelLower === 'muito bom') {
        return '#90EE90'; // Verde claro
    } else if (labelLower.includes('insatisfatório') || labelLower === 'insatisfatório' || labelLower === 'insatisfatorio') {
        return '#dc3545'; // Vermelho forte
    } else if (labelLower.includes('satisfatório') || labelLower === 'satisfatório' || labelLower === 'satisfatorio') {
        return '#ffc107'; // Amarelo mais escuro/laranja claro para diferenciar de Regular
    }
    
    // Escala satisfeito/insatisfeito (verificar "muito" ANTES de simples, pois contém a palavra)
    if (labelLower.includes('muito insatisfeito') || labelLower === 'muito insatisfeito') {
        return '#dc3545'; // Vermelho forte
    } else if (labelLower.includes('muito satisfeito') || labelLower === 'muito satisfeito') {
        return '#28a745'; // Verde forte
    } else if (labelLower === 'insatisfeito' || (labelLower.includes('insatisfeito') && !labelLower.includes('muito'))) {
        return '#ff9800'; // Laranja
    } else if (labelLower === 'satisfeito' || (labelLower.includes('satisfeito') && !labelLower.includes('muito'))) {
        return '#90EE90'; // Verde claro
    }
    
    // Escala de recomendação (verificar ANTES de Sim/Não genérico, pois contém essas palavras)
    if (labelLower.includes('recomendaria com certeza') || labelLower === 'recomendaria com certeza') {
        return '#28a745'; // Verde forte
    } else if (labelLower.includes('provavelmente sim') || labelLower === 'provavelmente sim') {
        return '#90EE90'; // Verde claro
    } else if (labelLower.includes('provavelmente não') || labelLower === 'provavelmente não' || labelLower === 'provavelmente nao' || labelLower.includes('provavelmente nao')) {
        return '#ff9800'; // Laranja
    } else if (labelLower === 'talvez' || labelLower.includes('talvez')) {
        return '#ffeb3b'; // Amarelo claro
    } else if (labelLower.includes('não recomendaria') || labelLower === 'não recomendaria' || labelLower === 'nao recomendaria' || labelLower.includes('nao recomendaria')) {
        return '#dc3545'; // Vermelho forte
    }
    
    // Respostas Sim/Não (apenas para respostas simples, não compostas - verificar EXATAMENTE para evitar pegar "Provavelmente Sim")
    if (labelLower === 'sim' && !labelLower.includes('provavelmente')) {
        return '#28a745'; // Verde forte
    } else if ((labelLower === 'não' || labelLower === 'nao') && !labelLower.includes('provavelmente') && !labelLower.includes('recomendaria')) {
        return '#dc3545'; // Vermelho forte
    }
    
    
    // Cor padrão caso não encontre correspondência
    return '#6c757d';
};

/**
 * Função para obter cores para um array de labels
 * @param {string[]} labels - Array de labels
 * @returns {string[]} - Array de cores correspondentes
 */
export const getColorsForLabels = (labels) => {
    return labels.map(label => getColorForResponse(label));
};

